import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { PublicLayout } from './PublicPages';

export default function NotFound() {
  return <PublicLayout><main className="prose-page"><p className="eyebrow">404 · A MISSED CONNECTION</p><h1>This page has<br/>moved on.</h1><p>The link may be out of date, or there may be a typo in the address. Let’s get you back to your next introduction.</p><div className="row"><a className="button primary" href="/">Back to Relay <ArrowUpRight size={18}/></a><Link className="button secondary" to="/app">Open my cards</Link></div><p>Need a hand? <Link to="/support">Contact support</Link>.</p></main></PublicLayout>;
}
